let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("68sdQ")).then(() => parcelRequire('eCiTS'));